<style lang="scss" scoped>
    .instructions {
        font-weight: bold;
        color: #4d8ab7;
        font-size: 1.2em;
    }
</style>

<template>
    <!-- <div :id="videoEmbedId" ref="videoContainer"></div> -->
    <div>
        <div class="instructions mb-4">
            <slot name="instructions">
                Click Play to start the training. You will be asked to pause to reflect and answer a couple questions along the way. Make sure you write down the quiz code at the end of the video. You will need this to access the Knowledge Quiz.
            </slot>
        </div>

        <div style="position: relative; padding-bottom: 56.25%; padding-top: 0px; overflow: auto; -webkit-overflow-scrolling: touch;">
            <iframe :src="videoUrl" frameborder="0" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;" scrolling="yes" allowfullscreen></iframe>
            <survey-modal
                :training-session="trainingSession"
                survey-type="knowledge-quiz"
            ></survey-modal>
        </div>
    </div>
</template>

<script>

    import SurveyModal from './SurveyModal';
    import { mapState } from 'vuex';

    export default{
        components: {
            SurveyModal
        },
        props: {
            trainingId: {
                type: Number,
                default: null
            },
            videoParams: {
                type: Object,
                default() {
                    return {
                        embedAsThumbnail: false,
                        displayTitle: false,
                        startTime: 0,
                        autoPlay: false,
                        hideControls: false,
                        hideControls: false,
                        showCaptions: false,
                        displaySharing: false,
                        displayAnnotations: false,
                        displayAttachments: false,
                        displayLinks: false,
                        displayEmbedCode: false,
                        displayDownloadIcon: false,
                        displayMetaData: false,
                        displayCredits: false,
                        audioPreviewImage: false,
                        displayCaptionSearch: false,
                        displayViewersReport: false,
                        displayAxdxs: false
                    }
                }
            }
        },
        data(){
            return {
                videoEmbedId: ""
            }
        },
        methods: {
            embedVideo: function() {
                let videoPlayer = document.createElement('script');
                let params = (new URL(this.videoUrl)).searchParams;

                videoPlayer.setAttribute('src', this.videoUrl + this.queryParamStr);
                videoPlayer.setAttribute('type', 'text/javascript');

                this.videoEmbedId = params.get('embedId');
                this.$refs.videoContainer.after(videoPlayer);
            }
        },
        computed: {
            training: function() {
                return this.trainings[this.trainingId];
            },
            queryParamStr: function() {
                let queryParams = this.$props.videoParams;
                let str = "";

                Object.keys(queryParams).forEach(item => {
                    str += ("&" + item + "=" + queryParams[item]);
                });
                return str;
            },
            videoUrl: function() {
                if(this.training) {
                    return this.training.video_url;
                }
                return "";
            },
            ...mapState([
                'trainings',
            ]),
        },
        mounted: function() { 
            // this.embedVideo();
        }
    }
</script>


